<template>
  <div>
    <mz-connect v-if="!device.connected" :device="device"></mz-connect>
    <mz-disconnect v-else :device="device"></mz-disconnect>
  </div>
</template>

<script>
import Connect from '@/components/Connect'
import Disconnect from '@/components/Disconnect'
import moment from 'moment'

import { mapGetters, mapMutations } from 'vuex'

const debug = window.debug('mz-controls')

export default {
  name: 'controls',
  data () {
    return {
      device: null
    }
  },
  components: {
    mzConnect: Connect,
    mzDisconnect: Disconnect
  },
  computed: {
    ...mapGetters(['connected', 'currentVib', 'currentLife'])
  },
  methods: {
    ...mapMutations(['setConnected', 'updateHistory', 'updateLife']),
    dateString (d, fmt) {
      fmt = fmt || 'HH:mm:ss'
      return moment(d).format(fmt)
    }
  },
  created () {
    this.device = window.mzBleDevice

    this.device.on('connected', () => {
      this.setConnected(true)
      this.device.start()
      this.$store.state.connectedAt = Date.now()
    })

    this.device.on('disconnected', () => {
      this.setConnected(false)
      this.$store.state.disconnectedAt = Date.now()
    })

    this.device.on('data', (msg) => {
      debug(msg)
      this.updateHistory({ tag: 'vib', point: { x: new Date(msg.ts), y: msg.vib } })
      this.updateHistory({ tag: 'temp', point: { x: new Date(msg.ts), y: msg.temp } })

      this.updateLife({ currentLife: this.currentLife, currentVib: this.currentVib })

      this.$store.state.updatedAt = Date.now()
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Controls.vue